module.exports = __webpack_public_path__ + "img/1558975037.dafd892a.jpg";